__turbopack_context__.v({
  "accountLink": "aside-module__JCdDKa__accountLink",
  "aside": "aside-module__JCdDKa__aside",
  "closeButton": "aside-module__JCdDKa__closeButton",
  "dialog": "aside-module__JCdDKa__dialog",
  "menuLink": "aside-module__JCdDKa__menuLink",
  "menuList": "aside-module__JCdDKa__menuList",
  "overlay": "aside-module__JCdDKa__overlay",
  "panelBody": "aside-module__JCdDKa__panelBody",
  "panelHeader": "aside-module__JCdDKa__panelHeader",
  "panelTitle": "aside-module__JCdDKa__panelTitle",
  "searchAside": "aside-module__JCdDKa__searchAside",
  "searchForm": "aside-module__JCdDKa__searchForm",
  "searchInput": "aside-module__JCdDKa__searchInput",
  "searchInputLabel": "aside-module__JCdDKa__searchInputLabel",
  "searchInputLabelHidden": "aside-module__JCdDKa__searchInputLabelHidden",
  "searchInputRow": "aside-module__JCdDKa__searchInputRow",
  "searchReset": "aside-module__JCdDKa__searchReset",
  "searchResetSlot": "aside-module__JCdDKa__searchResetSlot",
  "searchResetSlotVisible": "aside-module__JCdDKa__searchResetSlotVisible",
  "searchResult": "aside-module__JCdDKa__searchResult",
  "searchResultTitle": "aside-module__JCdDKa__searchResultTitle",
  "searchResults": "aside-module__JCdDKa__searchResults",
  "searchResultsWrap": "aside-module__JCdDKa__searchResultsWrap",
  "searchStatus": "aside-module__JCdDKa__searchStatus",
  "searchSubmit": "aside-module__JCdDKa__searchSubmit",
  "searchSubmitVisible": "aside-module__JCdDKa__searchSubmitVisible",
  "searchThumb": "aside-module__JCdDKa__searchThumb",
  "searchThumbPlaceholder": "aside-module__JCdDKa__searchThumbPlaceholder",
  "searchViewAll": "aside-module__JCdDKa__searchViewAll",
  "searchViewAllTerm": "aside-module__JCdDKa__searchViewAllTerm",
});
